import React, { useEffect, useState } from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as S from '../users-logs/styles';
import {
  LogListItem,
  ModalResponsive,
  Loading,
  Pagination,
  DynamicFilter,
} from '../../components';
import Details from '../../assets/buttons/details.svg';
import { useLogs } from '../../hooks';
import {
  formatTimeStampToDate,
  mapNumbersToString,
} from '../../utils/functions';
import {
  IDynamicFilterData,
  IDynamicFilterSelectOptions,
} from '../../interfaces';
import { usePagination } from '../../hooks/usePagination';

export const ShippingLogs: React.FC = () => {
  const { returnAllShippingLogs, shippingLogs, isLoading, metadata } =
    useLogs();

  const [activeUser, setActiveUser] = useState<any>(null);

  const [OpenDetailsModal, setOpenDetailsModal] = useState(false);

  const today = new Date().toISOString().split('T')[0];
  const fortyFiveDaysAgo = new Date();
  fortyFiveDaysAgo.setDate(fortyFiveDaysAgo.getDate() - 45);
  const dateStart = fortyFiveDaysAgo.toISOString().split('T')[0];

  const [filters, setFilters] = useState<IDynamicFilterData>({
    type: 'enviou',
    term: '',
    dateStart,
    dateEnd: today,
  });

  const { currentPage, pageSize, handlePageChange, resetPagination } =
    usePagination({
      totalItems: metadata.totalItems || 0,
      onPageChange: (currentPage, pageSize) => {
        returnAllShippingLogs({
          type: filters.type,
          term: filters.term,
          currentPage,
          pageSize,
          dateStart: filters.dateStart,
          dateEnd: filters.dateEnd,
        });
      },
    });

  useEffect(() => {
    returnAllShippingLogs({
      type: filters.type,
      term: filters.term,
      currentPage: 1,
      pageSize,
      dateStart: filters.dateStart,
      dateEnd: filters.dateEnd,
    });
  }, []);

  const handleOpenDetails = (elm: any) => {
    setActiveUser(elm);
    setOpenDetailsModal(true);
  };

  const handleSearch = (formData: IDynamicFilterData) => {
    setFilters(formData);
    resetPagination();
    returnAllShippingLogs({
      type: formData.type,
      term: formData.term,
      currentPage: 1,
      pageSize,
      dateStart: formData.dateStart,
      dateEnd: formData.dateEnd,
    });
  };

  const filterSelectOptions: IDynamicFilterSelectOptions[] = [
    { value: 'enviou', description: 'E-mail que enviou' },
    { value: 'recebeu', description: 'E-mail que recebeu' },
  ];

  return (
    <S.Container>
      <S.Content>
        <DynamicFilter
          filterSelectOptions={filterSelectOptions}
          filters={filters}
          calendar
          isLoading={isLoading}
          setFilters={setFilters}
          searchFilters={handleSearch}
        />
        <S.Tabs.TabsContainer>
          {!isLoading && (
            <S.ResponsiveTabHeader>
              <S.ResponsiveTabCell>Enviado por</S.ResponsiveTabCell>
              <S.ResponsiveTabCell>Enviado para</S.ResponsiveTabCell>
              <S.ResponsiveTabCell>Data do envio</S.ResponsiveTabCell>
              <S.ResponsiveTabCell>Tipo (Boleto ou DANFE)</S.ResponsiveTabCell>
              <S.ResponsiveTabCell>Número da Nota</S.ResponsiveTabCell>
            </S.ResponsiveTabHeader>
          )}

          {shippingLogs.map((elm: any) => (
            <S.ResponsiveTabBody key={elm.idUsuarioEnvio}>
              <S.ResponsiveTabCell data-label="Enviado por">
                {elm.enviadoPor ?? '-'}
              </S.ResponsiveTabCell>

              <S.ResponsiveTabCell data-label="Enviado para">
                {elm.enviadoPara ?? '-'}
              </S.ResponsiveTabCell>

              <S.ResponsiveTabCell data-label="Data do envio">
                {formatTimeStampToDate(elm.dataEvento)}
              </S.ResponsiveTabCell>

              <S.ResponsiveTabCell data-label="Tipo">
                {elm.tipoDocumento ?? '-'}
              </S.ResponsiveTabCell>

              <S.ResponsiveTabCell data-label="Número da Nota">
                {elm.numeroNota !== '' ? elm.numeroNota : '-'}
              </S.ResponsiveTabCell>
            </S.ResponsiveTabBody>
          ))}
        </S.Tabs.TabsContainer>

        {!isLoading && shippingLogs.length === 0 && (
          <S.Message>Nenhum resultado encontrado.</S.Message>
        )}

        {!isLoading && shippingLogs.length !== 0 && (
          <Pagination
            currentPage={currentPage}
            paginationSize={pageSize}
            onPageChange={handlePageChange}
            totalItems={metadata.totalItems}
          />
        )}
      </S.Content>

      <ToastContainer
        closeButton={false}
        transition={Slide}
        position="bottom-center"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </S.Container>
  );
};
